<ul class="nav nav-pills flex-column" [class.minMenu]="minMenu">
    <li role="presentation" class="nav-item">
      <div class="container nav-link">
        <div class="row ">
          <div class="col-sm-9">
            <a class="" (click)="toggleMenu()"><i class="fas fa-list" aria-hidden="true"></i><span class="menuText">Menu</span></a>
          </div>
          <div class="col-sm-3 toggleIndicator">
            <a class="" (click)="toggleMenu()"><i class="fas fa-angle-double-left"></i></a>
          </div>
        </div>
        </div>
    </li>
    <li [class.active]="stateService.includes('authenticated.dashboard.view')" role="presentation"
        class="nav-item">
        <a class="nav-link"  uiSref="authenticated.dashboard.view"  uiSrefActive="active">
                <div class="circle"><i class="fas fa-newspaper" aria-hidden="true"></i></div><span class="menuText">Dashboard</span></a>
    </li>
    <ng-template [areBuildingsRequired]="true">
        <li [class.active]="stateService.includes('authenticated.supervision-management') || (stateService.includes('authenticated.user-summary') && !viewingCurrentUser)" role="presentation"
            class="nav-item"
            *permissionsAll="[PermissionTypes.PAETEP_SMUI]">
            <a class="nav-link" uiSref="authenticated.supervision-management.view" uiSrefActive="active" [attr.aria-expanded]="!supervisorManagementCollapsed" aria-controls="supervisionManagementMenu">
                    <div class="circle"><i class="fas fa-check-circle" aria-hidden="true"></i></div><span class="menuText">Supervision Management</span></a>
        </li>
    </ng-template>
    <ng-template [areBuildingsRequired]="true">
        <li [class.active]="viewingCurrentUser" role="presentation" class="nav-item" *permissionsAll="[PermissionTypes.PAETEP_USER_SUMMARY_CAN_VIEW_MY_OBSERVATIONS]">
            <a class="nav-link" uiSref="authenticated.user-summary.view" [uiParams]="{ userId: user?.UserID}"  uiSrefActive="active"  >
            <div class="circle"><i class="fas fa-check" aria-hidden="true"></i></div> <span class="menuText">My Observations </span></a>
        </li>
    </ng-template>
    <li  role="presentation" class="nav-item" *permissionsAll="[PermissionTypes.FILE_ATTACHMENTS]">
      <a class="nav-link" uiSref="authenticated.attachments.myattachments" [uiParams]="{ userId: user?.UserID}"  uiSrefActive="active"  >
        <div class="circle"><i class="fas fa-paperclip" aria-hidden="true"></i></div> <span class="menuText">Attachment Management</span></a>
    </li>
    <ng-template [areBuildingsRequired]="true">
        <li [class.active]="stateService.includes('authenticated.reporting')" role="presentation" class="nav-item" *permissionsAny="[PermissionTypes.REPORTING]">
            <a class="nav-link"
                uiSref="authenticated.reporting"
                uiSrefActive="active"
                [uiOptions]="{reload: true}"
                aria-controls="reportingMenu"
                (click)="reportingCollapsed = !reportingCollapsed" [attr.aria-expanded]="!reportingCollapsed">
                <div class="circle">
                    <i class="far fa-chart-bar" aria-hidden="true"></i>
                </div>
                <span class="menuText">Reporting</span>
            </a>
            <ul class="sub-nav" style="margin-bottom: 5px;" id="reportingSubMenu" [ngbCollapse]="reportingCollapsed">
                <li>
                    <a uiSref="authenticated.reporting.observation-summary-report" *permissionsAll="[PermissionTypes.REPORTING_OBS_SUMMARY]" [uiOptions]="{reload: true}" uiSrefActive="active">Observation Summary Report</a>
                </li>
                <li>
                    <a uiSref="authenticated.reporting.components-report" *permissionsAll="[PermissionTypes.REPORTING_COMPONENT]" [uiOptions]="{reload: true}" uiSrefActive="active">Component Report</a>
                </li>
                <li>
                    <a uiSref="authenticated.reporting.growth-and-strengths-report" *permissionsAll="[PermissionTypes.REPORTING_GROWTH_AND_STRENGTH]" [uiOptions]="{reload: true}" uiSrefActive="active">Growth & Strength Report</a>
                </li>
                <li>
                    <a uiSref="authenticated.reporting.eear.individual" *permissionsAll="[PermissionTypes.REPORTING_EDU_EFFECT_INDIVIDUAL]" [uiOptions]="{reload: true}" uiSrefActive="active">Educator Effectiveness Annual Report (EEAR)</a>
                </li>
            </ul>
        </li>
    </ng-template>
    <li [class.active]="stateService.includes('authenticated.users')" role="presentation" class="nav-item" *permissionsAll="[PermissionTypes.ADMINISTRATION_USER_MANAGEMENT]">
        <a class="nav-link" uiSref="authenticated.users.view" [uiParams]="{ page: 1 }" [uiOptions]="{reload: true}" uiSrefActive="active"
            (click)="userManagementCollapsed = !userManagementCollapsed" [attr.aria-expanded]="!userManagementCollapsed"
            aria-controls="usersMenu"><div class="circle"><i class="fas fa-user" aria-hidden="true"></i></div><span class="menuText">User Management</span></a>
        <ul class="sub-nav" style="margin-bottom: 5px;" id="userManagementSubMenu" [ngbCollapse]="userManagementCollapsed">
            <li>
                <a  uiSref="authenticated.users.view" [uiParams]="{ page: 1 }" [uiOptions]="{reload: true}" uiSrefActive="active">All Users</a>
            </li>
           <!-- <li>
                <a  uiSref="authenticated.users.bulkupdate" uiSrefActive="active">Bulk Update Users</a>
            </li> -->
            <li>
              <a  uiSref="authenticated.users.onboarding" uiSrefActive="active">User Onboarding</a>
          </li>
        </ul>
    </li>
    <ng-template [areBuildingsRequired]="true">
        <li [class.active]="isActive(ADMINISTRATION_STATES)" role="presentation" class="nav-item" *permissionsAny="[PermissionTypes.ADMINISTRATION, PermissionTypes.PAETEP_CUSTOM_FORMS_BUILDER]">
            <a class="nav-link" uiSref="authenticated.administration.landing" uiSrefActive="active"  aria-controls="portalMenu"
            (click)="administrationCollapsed = !administrationCollapsed" [attr.aria-expanded]="!administrationCollapsed">
                <div class="circle"><i class="fas fa-cog" aria-hidden="true"></i></div><span class="menuText">Administration</span></a>
            <ul class="sub-nav" style="margin-bottom: 5px;" id="portalManagementSubMenu" [ngbCollapse]="administrationCollapsed">
                <li>
                    <a  uiSref="authenticated.assignments.view" *permissionsAll="[PermissionTypes.ASSIGNMENTS_CAN_ASSIGN_TO_BUILDINGS]"  [uiOptions]="{reload: true}" [class.active]="stateService.includes('authenticated.assignments')">Assignment Management</a>
                </li>
                <li>
                    <a  uiSref="authenticated.buildings.view" *permissionsAll="[PermissionTypes.ADMINISTRATION_BUILDINGS]"  [uiOptions]="{reload: true}" [class.active]="stateService.includes('authenticated.buildings')">Building Management</a>
                </li>
                <li>
                    <a  uiSref="authenticated.custom-form-builder.custom-forms" *permissionsAll="[PermissionTypes.PAETEP_CUSTOM_FORMS_BUILDER]"  [uiOptions]="{reload: true}" [class.active]="stateService.includes('authenticated.custom-form-builder')">Custom Form Management</a>
                </li>
                <li>
                <a  uiSref="authenticated.administration.ratingform" *permissionsAll="[PermissionTypes.ADMINISTRATION_RATING_FORM_MANAGEMENT]"  [uiOptions]="{reload: true}" [class.active]="stateService.includes('authenticated.administration.ratingform')">Rating Form Management</a>
            </li>
                <li>
                    <a  uiSref="authenticated.administration.portalSettings" *permissionsAll="[PermissionTypes.IS_SUPER_ADMIN]" [uiOptions]="{reload: true}" uiSrefActive="active">Portal Settings</a>
                </li>
                <li>
                    <a  uiSref="authenticated.preset-management.pg.view" *permissionsAll="[PermissionTypes.PRESET_MANAGEMENT]"  [uiOptions]="{reload: true}" [class.active]="stateService.includes('authenticated.preset-management')">Preset Management</a>
                </li>
                <li>
                    <a  uiSref="authenticated.portal.emailcontent" *permissionsAll="[PermissionTypes.IS_SUPER_ADMIN]" [uiParams]="{ page: 1 }" [uiOptions]="{reload: true}" uiSrefActive="active">Email Content</a>
                </li>
                <li>
                    <a  uiSref="authenticated.administration.styleExample" *permissionsAll="[PermissionTypes.IS_SUPER_ADMIN]" [uiParams]="{ page: 1 }"  [uiOptions]="{reload: true}" uiSrefActive="active">Styling Example</a>
                </li>
                <li>
                    <a  uiSref="authenticated.administration.alert" *permissionsAll="[PermissionTypes.IS_SUPER_ADMIN]" [uiParams]="{ page: 1 }"  [uiOptions]="{reload: true}" uiSrefActive="active">Alert Content</a>
                </li>
            </ul>
        </li>
    </ng-template>
    <li [class.active]="stateService.includes('authenticated.permissions')" role="presentation" class="nav-item" *permissionsAll="[PermissionTypes.IS_SUPER_ADMIN, PermissionTypes.ADMINISTRATION_PERMISSIONS]">
        <a class="nav-link"
            uiSref="authenticated.permissions.permissionSettings"
            uiSrefActive="active"
            [uiOptions]="{reload: true}"
            aria-controls="permissionsMenu"
            (click)="permissionsCollapsed = !permissionsCollapsed" [attr.aria-expanded]="!permissionsCollapsed">
            <div class="circle">
                <i class="fas fa-lock" aria-hidden="true"></i>
            </div>
            <span class="menuText">Permissions</span>
        </a>
        <ul class="sub-nav" style="margin-bottom: 5px;" id="permissionsSubMenu" [ngbCollapse]="permissionsCollapsed">
            <li>
                <a uiSref="authenticated.permissions.permissionSettings" *permissionsAll="[PermissionTypes.ADMINISTRATION_PERMISSIONS_CAN_VIEW_ALL]" [uiOptions]="{reload: true}" uiSrefActive="active">Permissions Settings</a>
            </li>
            <li>
                <a uiSref="authenticated.permissions.edit" *permissionsAll="[PermissionTypes.ADMINISTRATION_PERMISSIONS_CAN_EDIT_ROLES]" [uiOptions]="{reload: true}" uiSrefActive="active">Edit Permissions</a>
            </li>
        </ul>
    </li>
</ul>
